import { randAlphaNumeric } from '@ngneat/falso'
import { Factory, Model } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'
import { createErrorResponse } from './utils.js'
import {
  SPEECHMATICS_REGION,
  SPEECHMATICS_TOKEN_TYPE,
} from '@/composables/speechmatics.js'

export type SpeechmaticsTokenData = SchemaAttributes<'SpeechmaticsToken'>

export const model = Model as ModelDefinition<SpeechmaticsTokenData>

export const factory = Factory.extend<SpeechmaticsTokenData>({
  token_type() {
    return SPEECHMATICS_TOKEN_TYPE.REALTIME
  },
  region() {
    return SPEECHMATICS_REGION.EUROPE
  },
  token() {
    return String(randAlphaNumeric({ length: 32 }))
  },
  ttl() {
    return 28800 // 8 hours
  },
})

export function routes(server: MockServer) {
  server.post('/ai/speechmatics_token', function (schema, request) {
    const config = useRuntimeConfig()
    const body = JSON.parse(request.requestBody)
    const attributes = body.data?.attributes || {}
    const ttl = attributes.ttl ?? config.public.speechmatics.defaultTokenTtl

    if (typeof ttl !== 'number' || isNaN(ttl)) {
      return createErrorResponse({
        status: 400,
        errors: [{ detail: 'TTL must be a valid number' }],
      })
    }

    // Speechmatics allows TTL range 60-86400 seconds as per schema
    if (ttl < 60 || ttl > 86400) {
      return createErrorResponse({
        status: 400,
        errors: [{ detail: 'TTL must be between 60 and 86400 seconds' }],
      })
    }

    // Generate a new token with the requested TTL
    const token = server.create('speechmatics', {
      ...attributes,
      ttl,
    })

    return token
  })
}

export function seeds(_server: MockServer) {
  // No seeds needed - tokens are generated on-demand
}
